import { Box } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'

export function DVD(props: {
  containerWidth: number
  containerHeight: number
  initialX: number
  initialY: number
  radius: number
  text: string
}) {
  enum MoveDirection {
    SOUTHWEST,
    SOUTHEAST,
    NORTHWEST,
    NORTHEAST,
  }

  // Define x and y as the center of the ball
  const [x, setX] = useState(props.initialX)
  const [y, setY] = useState(props.initialY)

  const [move, setMove] = useState(false)
  const [direction, setDirection] = useState(MoveDirection.SOUTHWEST)

  const boundaries = useMemo(
    () => ({
      bottom: props.containerHeight - props.radius / 2,
      right: props.containerWidth - props.radius / 2,
      top: props.radius / 2,
      left: props.radius / 2,
    }),
    [props.containerHeight, props.containerWidth, props.radius]
  )

  useEffect(() => {
    if (move) {
      const VELOCITY = 3

      const interval = setInterval(() => {
        let newX
        let newY
        switch (direction) {
          case MoveDirection.SOUTHWEST:
            newX = x - VELOCITY
            newY = y + VELOCITY

            if (newX < boundaries.left) {
              setDirection(MoveDirection.SOUTHEAST)
              return
            }

            if (newY > boundaries.bottom) {
              setDirection(MoveDirection.NORTHWEST)
              return
            }

            setX(newX)
            setY(newY)
            break
          case MoveDirection.SOUTHEAST:
            newX = x + VELOCITY
            newY = y + VELOCITY

            if (newX > boundaries.right) {
              setDirection(MoveDirection.SOUTHWEST)
              return
            }

            if (newY > boundaries.bottom) {
              setDirection(MoveDirection.NORTHEAST)
              return
            }

            setX(newX)
            setY(newY)
            break
          case MoveDirection.NORTHWEST:
            newX = x - VELOCITY
            newY = y - VELOCITY

            if (newX < boundaries.left) {
              setDirection(MoveDirection.NORTHEAST)
              return
            }

            if (newY < boundaries.top) {
              setDirection(MoveDirection.SOUTHWEST)
              return
            }

            setX(newX)
            setY(newY)
            break
          case MoveDirection.NORTHEAST:
            newX = x + VELOCITY
            newY = y - VELOCITY

            if (newX > boundaries.right) {
              setDirection(MoveDirection.NORTHWEST)
              return
            }

            if (newY < boundaries.top) {
              setDirection(MoveDirection.SOUTHEAST)
              return
            }

            setX(newX)
            setY(newY)
            break
        }
      }, 5)

      return () => clearInterval(interval)
    }
  }, [
    MoveDirection.NORTHEAST,
    MoveDirection.NORTHWEST,
    MoveDirection.SOUTHEAST,
    MoveDirection.SOUTHWEST,
    boundaries.bottom,
    boundaries.left,
    boundaries.right,
    boundaries.top,
    direction,
    move,
    x,
    y,
  ])

  return (
    <Box
      sx={{
        position: 'absolute',
        top: y - props.radius / 2,
        left: x - props.radius / 2,
        bgcolor: 'rgb(240,253,108)',
        borderRadius: '50%',
        width: props.radius,
        height: props.radius,
        zIndex: 9999999,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        cursor: 'pointer',
        textAlign: 'center',
      }}
      onClick={() => {
        setMove(!move)
      }}
    >
      {props.text}
    </Box>
  )
}
